import type { Camera, Object3D, Vector2 } from 'three';
import { Plane, Raycaster, Vector3 } from 'three';

/**
 * 카메라와 캔버스 NDC 좌표로부터 raycaster 생성, objectList 중 ray와 intersection된 object를 반환하는 함수
 * @param ndc NDC 좌표
 * @param camera camera 객체
 * @param objects ray와 intersection 여부를 계산할 target objects
 * @returns intersections
 */
export const getIntersectObjectsByNDC = ({
  ndc,
  camera,
  objects,
}: {
  ndc: Vector2;
  camera: Camera;
  objects: Object3D[];
}) => {
  const raycaster = new Raycaster();
  raycaster.setFromCamera(ndc, camera);

  const intersections = raycaster.intersectObjects(objects);

  return intersections;
};

/**
 * 카메라와 캔버스 NDC 좌표로부터 raycaster 생성, coplanarPoint를 기준으로 한 평면과 ray와 intersection된 점을 반환하는 함수
 * @param ndc NDC 좌표
 * @param camera camera 객체
 * @param coplanarPoint 평면을 정의할 기준점
 * @returns intersection point
 */
export const getIntersectPlanePointByNDC = ({
  ndc,
  camera,
  coplanarPoint,
}: {
  ndc: Vector2;
  camera: Camera;
  coplanarPoint: Vector3;
}) => {
  const raycaster = new Raycaster();
  raycaster.setFromCamera(ndc, camera);

  const plane = new Plane().setFromNormalAndCoplanarPoint(
    camera.getWorldDirection(new Vector3()).clone(),
    coplanarPoint,
  );

  const intersectionPoint = new Vector3();
  raycaster.ray.intersectPlane(plane, intersectionPoint);

  return intersectionPoint;
};
